// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyD7EpeSR0dlnNF4mrtc-v8ZzLjinkuUrNA",
//   authDomain: "tabufy-8b870.firebaseapp.com",
//   projectId: "tabufy-8b870",
//   storageBucket: "tabufy-8b870.firebasestorage.app",
//   messagingSenderId: "178260761747",
//   appId: "1:178260761747:web:586cc3fcd55308816e0166",
//   measurementId: "G-66ETL6PN4J",
// };




// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCbBHDuSJzBmYIqXIYk06LC5miLPFjESio",
//   authDomain: "tabufy-production.firebaseapp.com",
//   projectId: "tabufy-production",
//   storageBucket: "tabufy-production.firebasestorage.app",
//   messagingSenderId: "684768834092",
//   appId: "1:684768834092:web:0b85f614b48af683105789",
//   measurementId: "G-EDHZ6J797T"
// };
//
// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
// const analytics = getAnalytics(app);
// export const db = getFirestore(app);


const firebaseConfig = {
  apiKey: "AIzaSyCbBHDuSJzBmYIqXIYk06LC5miLPFjESio",
  authDomain: "tabufy-production.firebaseapp.com",
  projectId: "tabufy-production",
  storageBucket: "tabufy-production.appspot.com",
  messagingSenderId: "684768834092",
  appId: "1:684768834092:web:0b85f614b48af683105789",
  measurementId: "G-EDHZ6J797T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);






